<template>
    <div>
        <dynamic-toolbar
            :loading="loading"
            icon="mdi-invoice-list"
            title="Maintenance Invoices"
            color="indigo"
            theme="dark"
        >
            <template #buttons>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="#fff"
                            depressed
                            outlined
                            large
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon left>mdi-import</v-icon>
                            Massive File Import
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(type, index) in invoiceTypes"
                            :key="index"
                            @click="openMassiveFileImport(type)"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ type.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{
                                type.name
                            }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    color="#24A39D"
                    depressed
                    class="ml-2"
                    large
                    dark
                    @click="getWeeklyReport()"
                >
                    <v-icon left>mdi-calendar-text-outline</v-icon>
                    Weekly Report
                </v-btn>
                <v-btn
                    color="teal"
                    depressed
                    class="ml-2"
                    large
                    dark
                    :to="'/maintenance/reports'"
                >
                    <v-icon left>mdi-file-chart</v-icon>
                    Reports
                </v-btn>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="success"
                            class="ml-2"
                            depressed
                            large
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon left>mdi-plus</v-icon>
                            New Invoice
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(type, index) in invoiceTypes"
                            :key="index"
                            @click="openInvoiceDialog(type, 'new')"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ type.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{
                                type.name
                            }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </dynamic-toolbar>
        <v-card>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12">
                        <invoice-table
                            :types="invoiceTypes"
                            :type="invoiceType"
                            :invoiceHeaders="invoiceHeaders"
                            :expenseHeaders="expenseHeaders"
                            @update:type="invoiceType = $event"
                            @update:loading="loading = $event"
                            @edit:item="
                                openInvoiceDialog(invoiceType, 'edit', $event)
                            "
                            ref="invoiceTableRef"
                        ></invoice-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <invoice-create-dialog
            :dialogStatus="invoiceDialogStatus"
            :invoiceHeaders="invoiceHeaders"
            :expenseHeaders="expenseHeaders"
            :types="invoiceTypes"
            :type="invoiceType"
            :dialogType="dialogType"
            :invoice="Object.keys(payload).length === 0 ? {} : payload"
            @update:status="invoiceDialogStatus = $event"
            @update:invoices="getInvoices()"
        />
        <invoice-file-import
            :importDialogStatus="importDialogStatus"
            :type="invoiceType"
            @update:status="importDialogStatus = $event"
        ></invoice-file-import>
    </div>
</template>

<script>
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import InvoiceTable from '../../components/Maintenance/InvoiceTable.vue';
import InvoiceCreateDialog from '../../components/Maintenance/InvoiceCreateDialog.vue';
import InvoiceFileImport from '../../components/Maintenance/InvoiceFileImport.vue';
import axios from 'axios';
// import * as XLSX from 'xlsx';
import { computed } from 'vue';

export default {
    name: 'MaintenanceInvoices',
    components: {
        DynamicToolbar,
        InvoiceTable,
        InvoiceCreateDialog,
        InvoiceFileImport
    },
    data() {
        return {
            // authentication: null,
            invoiceDialogStatus: false,
            loading: false,
            payload: {},
            dialogType: 'new',
            invoiceTypes: [
                {
                    id: 1,
                    name: 'Trailer',
                    value: 'trailer',
                    axios: 'trailers',
                    laravel: 'App\\Trailer',
                    icon: 'mdi-train-car-tank'
                },
                {
                    id: 2,
                    name: 'Truck',
                    value: 'truck',
                    axios: 'trucks',
                    laravel: 'App\\Truck',
                    icon: 'mdi-truck-flatbed'
                },
                {
                    id: 3,
                    name: 'Supplies',
                    value: 'supplies',
                    axios: 'supplies',
                    laravel: 'App\\Supply',
                    icon: 'mdi-package-variant-closed'
                }
            ],
            invoiceType: {
                id: 1,
                name: 'Trailer',
                value: 'trailer',
                axios: 'trailers',
                laravel: 'App\\Trailer',
                icon: 'mdi-train-car-tank'
            },

            invoiceHeaders: [
                { text: 'ID', value: 'id', align: ' d-none' },
                { text: 'Invoice Number', value: 'invoice_number' },
                { text: 'Region', value: 'region.name' },
                {
                    text: 'P.O. Number',
                    value: 'purchase_order.purchase_order_number'
                },
                { text: 'Equipment', value: 'model' },
                { text: 'Company', value: 'company.CompanyName' },
                { text: 'Vendor', value: 'vendor.name' },
                { text: 'TaxRegion', value: 'tax_region.name' },
                { text: 'Created By', value: 'user.email' },
                { text: 'Invoice Date', value: 'invoice_issued_at' },
                { text: 'Subtotal Cost', value: 'subtotal_cost' },
                { text: 'Total Cost', value: 'total_cost' },
                {
                    text: 'Expenses',
                    value: 'data-table-expand',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                }
            ],
            expenseHeaders: [
                {
                    text: 'Expense Category',
                    value: 'category'
                },
                {
                    text: 'Expense Subcategory',
                    value: 'subcategory'
                },
                { text: 'Description', value: 'description' },
                { text: 'Comments', value: 'comments' },
                { text: 'Tax Rate', value: 'custom_tax_rate' },
                { text: 'Quantity', value: 'quantity' },
                { text: 'Unit Cost', value: 'unit_cost' },
                { text: 'Subtotal Cost', value: 'subtotal_cost' },
                { text: 'Tax', value: 'tax' },
                { text: 'Total Cost', value: 'total_cost' },
                {
                    text: 'Actions',
                    align: 'start',
                    sortable: false,
                    value: 'actions'
                }
            ],
            importDialogStatus: false,
        };
    },
    computed: {
        authentication() {
            return {
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            };
        },
    },
    methods: {
        updateInvoiceType(type) {
            this.invoiceType = type;
            console.log('Updating invoice type to', type);
        },
        openMassiveFileImport(type) {
            this.importDialogStatus = true;
            this.invoiceType = type;
        },
        openInvoiceDialog(type, dialogType, item = {}) {
            console.log('Opening invoice dialog', type, dialogType, item, type.value);
            let idx = this.expenseHeaders.findIndex(header => header.value == 'item');
            console.log("item header index", idx, this.expenseHeaders);
            if (type.value === 'supplies' && idx == -1) {
                this.expenseHeaders.splice(2, 0, {
                    text: 'Expense Item',
                    value: 'item'
                });
            } else if (type.value !== 'supplies' && idx != -1) {
                console.log("test")
                this.expenseHeaders.splice(idx, 1);
            }
            console.log("Expense Headers", this.expenseHeaders);

            if (dialogType == 'edit' && item.model && type.value == 'truck') {
                item.model_id = item.model.TruckID;
            } else if (dialogType == 'edit' && item.model && type.value == 'trailer') {
                item.model_id = item.model.TrailerId;
            } else if (dialogType == 'edit' && type.value == 'supplies') {
                item.model_id = null;
            }

            if (this.invoiceType.id !== type.id) {
                this.updateInvoiceType(type);
            }
            this.dialogType = dialogType ?? 'new';
            this.payload = item;
            this.invoiceDialogStatus = true;
        },
        getInvoices() {
            this.$refs.invoiceTableRef.getInvoices(true);
        },
        getWeeklyReport() {
            console.log("Weekly report");
            let str = this.$store;
            str.state.isLoading = true;
            axios
                .post(
                    '/v2/maintenance/reports/weekly/all-invoices', '',
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename = this.getReportFilename('xlsx');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        getReportFilename(requestType) {
            let currentDate = new Date();
            let year = currentDate.getFullYear();
            let month = String(currentDate.getMonth() + 1).padStart(2, '0');
            let day = String(currentDate.getDate()).padStart(2, '0');
            let hours = String(currentDate.getHours()).padStart(2, '0');
            let minutes = String(currentDate.getMinutes()).padStart(2, '0');
            let seconds = String(currentDate.getSeconds()).padStart(2, '0');

            let formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            console.log(formattedDateTime);

            return "WeeklyInvoiceReport_" + formattedDateTime + '.' + requestType;
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Maintenance Invoices';
            }
        }
    }
};
</script>
